import React from 'react';

import './actions.css';

interface IActionProps {
  children: any;
  noMargin?: boolean;
  noBorder?: boolean;
  scrollable?: boolean;
}

function Actions({
  children,
  noMargin,
  noBorder,
  scrollable,
}: IActionProps) {

  return (
    <>
      <header className={`table-header ${noMargin ? '' : 'mb-2'} w-full ${scrollable ? 'overflow-x-auto no-scrollbar' : ''} ${noBorder ? '' : 'border-b border-gray-200 dark:border-gray-700'} bg-theme-bg dark:bg-theme-bg`}>
        {scrollable ? <div className="w-full min-w-max">{children}</div> : children}
      </header>
    </>
  );
}

export default Actions;
